import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BolhaAtendimento from './components/BolhaAtendimento';
import AppRoutes from './AppRoutes';
import PularParaConteudo from './components/PularParaConteudo';
import AnunciadorDeRota from './components/AnunciadorDeRota';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { LayoutProvider } from './contexts/LayoutContext';
import { AcessibilidadeProvider } from './contexts/AcessibilidadeContext';
import './styles/App.css';
import './styles/Acessibilidade.css';
import './styles/AcessibilidadePreferencias.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AcessibilidadeProvider>
        <ToastProvider>
          <LayoutProvider>
            <Router>
              <div className="app-wrapper">
                <PularParaConteudo />
                <Navbar />
                <main className="main-content" id="conteudo-principal" tabIndex={-1}>
                  <AppRoutes />
                </main>
                <Footer />
                <AnunciadorDeRota />
                <BolhaAtendimento />
              </div>
            </Router>
          </LayoutProvider>
        </ToastProvider>
        </AcessibilidadeProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
